import { render, staticRenderFns } from "./EventcirclePagination.vue?vue&type=template&id=28132c48&scoped=true&"
import script from "./EventcirclePagination.vue?vue&type=script&lang=js&"
export * from "./EventcirclePagination.vue?vue&type=script&lang=js&"
import style0 from "./EventcirclePagination.vue?vue&type=style&index=0&id=28132c48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28132c48",
  null
  
)

export default component.exports